export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Electrical Technology Instructor Atlas after purchasing?',
    a: ['You receive instant digital access to the materials after your payment is successfully completed.'],
  },
  {
    q: 'What format is it in?',
    a: [
      'All materials are delivered as PDF files. You can print them as handouts or show them on a tablet, screen or projector in your classroom, electrical lab or training workshop.',
    ],
  },
  {
    q: 'Who is it for?',
    a: [
      'It is designed for electrical instructors, technical and vocational schools, community college electrical programs, apprenticeship and industry training centers, and experienced electricians who teach. Adjust the content to your students, your level, your own curriculum and your local electrical code.',
    ],
  },
  {
    q: 'What levels does it cover?',
    a: [
      'From beginner to advanced. Training pages include Easy, Standard and Advanced variants, so you can match each class to your students.',
    ],
  },
  {
    q: 'Does it work for beginner classes and advanced courses?',
    a: [
      'Yes. The material covers electrical fundamentals and safety, residential wiring and circuit protection, commercial and industrial systems, motors and controls, diagrams, testing and troubleshooting, PLCs, VFDs and smart electrical systems, and electrical teaching methods, so it works for introductory lab classes, apprenticeship programs, specialized courses and short workshops alike.',
    ],
  },
  {
    q: 'Is it really a 100% visual system?',
    a: [
      'Yes. The six volumes contain 300 visual training pages (50 per volume). Each page includes an illustration or labeled diagram, a step-by-step breakdown when it applies, a ❌ common mistake vs. ✅ correct method comparison, a teaching cue, a drill and a quick check. The five bonuses add practical teaching tools.',
    ],
  },
  {
    q: 'Does it include ready-to-teach lessons?',
    a: [
      'Yes. The system is built around a simple method — OPEN → CHOOSE → SHOW → TEACH — with lesson plans, demonstration guides, lab exercises, drills and quick checks you can use right away.',
    ],
  },
  {
    q: 'What topics does it cover?',
    a: [
      'Electrical fundamentals, circuit theory and electrical safety; residential electrical wiring, installations and circuit protection; commercial and industrial electrical systems, motors and controls; electrical diagrams, testing, troubleshooting and fault diagnosis; industrial automation, PLCs, variable frequency drives and smart electrical systems; and electrical instruction, workshop training and practical assessments.',
    ],
  },
  {
    q: 'Does it follow the NEC or IEC standards?',
    a: [
      'Both are shown. Where practices differ (for example conductor colors, receptacles or switching names), the pages label NEC (US) and IEC / UK examples side by side. Code values are teaching examples: always check the code and regulations that apply where you teach.',
    ],
  },
  {
    q: 'Does it replace an accredited electrical curriculum, licensing or certification?',
    a: [
      'No. This is educational teaching-support material for instructors. It does not replace an accredited electrical curriculum, electrician licensing, official certifications, your local electrical codes and regulations, equipment manufacturer instructions, workplace safety training or qualified professional supervision. Always follow your institution’s safety procedures, lockout/tagout rules and the applicable codes and standards.',
      'Results depend on each instructor, student and learning context, so no specific results are guaranteed.',
    ],
  },
  {
    q: 'Does it include all six volumes?',
    a: ['Yes. The complete package includes all six visual electrical systems and technical training volumes.'],
  },
  {
    q: 'Are the five bonuses included?',
    a: ['Yes. The five listed bonuses are included with the complete package at no additional cost under this offer.'],
  },
  {
    q: 'Does it include videos?',
    a: ['No. This is a digital educational resource package containing PDF materials. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. The materials are written in English for an international audience.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['The materials are provided as PDFs, not editable source files.'],
  },
  {
    q: 'Is this a one-time purchase?',
    a: ['Yes. The listed package is offered as a one-time payment, with no subscription.'],
  },
]
